import { ErrorMessage, useFormikContext } from 'formik'
import React from 'react'
import DatePicker from 'react-date-picker'

function InputFieldDate({ name, required, label, ...props }) {
  const formik = useFormikContext()
  return (
    <div>
      <label for={name} class='block mb-2 text-sm font-medium text-gray-900 '>
        {label}
        {required ? ' *' : ''}
      </label>
      <DatePicker
        onChange={(date) => {
          formik?.setFieldValue(name, date)
        }}
        value={new Date(formik?.values[name] || new Date())}
        onBlur={() => formik.setFieldTouched(name, true)}
        className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-2.5 py-[6.5px]`}
        // {...props}
      />
      {name && (
        <ErrorMessage
          name={name}
          component={'div'}
          className='text-xs text-red-500 font-light mt-1'
        />
      )}
    </div>
  )
}

export default InputFieldDate
